(function () {
    'use strict';

    angular.module('sempraWebapp').service('apiMockService', apiMockService);

    /** @ngInject */
    function apiMockService($http, $q, $timeout, apiErrorHandlerService) {

        var serverDelayMs = 100;
        /* eslint-disable */
        this.signIn = function (username, password) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({
                    username: username,
                    userId: 1,
                    accessToken: '123qwerty456asdfgh',
                    refreshToken: '123qwerty456asdfgh',
                    role: 'ADMIN',
                    firstName: 'Admin',
                    lastName: 'Demo'
                });
            }, serverDelayMs);

            return deferred.promise;
        };

        this.getWebSocketsToken = function () {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve('1234567890');
            }, serverDelayMs);

            return deferred.promise;
        };

        this.forgotPassword = function (email) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({
                    username: email,
                    userId: 1,
                    accessToken: '123qwerty456asdfgh',
                    refreshToken: '123qwerty456asdfgh',
                    role: 'ADMIN',
                    firstName: 'Admin',
                    lastName: 'Demo'
                });
            }, serverDelayMs);

            return deferred.promise;
        };

        this.updateUserInfo = function (data) {
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.addNewUser = function (data) {
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.deleteUser = function (userId) {
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.activateAccount = function (data) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.getDevices = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/devices.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getDeviceBySerialNumber = function (serialNumber) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/devices.json').success(function (data) {
                $timeout(function () {
                    var result = data.find(function (device) {
                        return device.deviceKey === serialNumber;
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.actuate = function (serialNumber, data) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.getMessages = function (deviceKey, fromTimeStamp, toTimestamp, page, pageSize) {
            var deferred = $q.defer(),
                start = page,
                end = pageSize;

            $http.get('../../../assets/mockData/messages.json').success(function (data) {
                var result = {
                    total: data.length,
                    data: data.slice(start * end, (start * end) + end)
                };
                $timeout(function () {
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getAlarmMessages = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/messages.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data.filter(function (message) {
                        return message.collapseKey === 'alarm';
                    }));
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getDailyFinances = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/dailyFinances.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getDailyFinancesBySerialNumber = function (serialNumber) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/dailyFinances.json').success(function (data) {
                $timeout(function () {
                    var result = data.facilities.find(function (facility) {
                        return facility.deviceSerial === serialNumber;
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getFinancesByDate = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalMoneyByDate.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalCoinsByDate = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalCoinsByDate.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalEuroKeyByDate = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalEuroKeyByDate.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getAvgMoneyByHours = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/avgMoneyByHours.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getAvgMoneyByDay = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/avgMoneyByDayOfWeek.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getAvgMoneyByBox = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/avgMoneyByBox.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalR2WByDate = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/dailyR2WReport.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getComparationForPeriod = function (deviceSerial, fromTimestamp1, toTimestamp1, fromTimestamp2, toTimestamp2) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/comparationReportForPeriod.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalByUserGroupsForPeriod = function (fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalUserGroupsByDate.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getVisitsCountForPeriod = function (fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalVisitsByMonth.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalSpentLocalTokensPerDay = function (fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/loyaltyPerDay.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getLoyaltyPerPaymentMethodForPeriod = function (fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/loyaltyPerPaymentMethod.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getLoyaltyTresholds = function (campaignId, type, tresholdValue, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/loyaltyTreshold.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        // sempra users

        this.getCompanyUsers = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/sempraUsers.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        // get all user roles
        this.getUserRoles = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/userRoles.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.searchSempraUsers = function (searchTerm) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/sempraUsers.json').success(function (data) {
                $timeout(function () {
                    var result = data.filter(function (user) {
                        if (user.username.indexOf(searchTerm) > -1 || user.firstName.indexOf(searchTerm) > -1
                            || user.lastName.indexOf(searchTerm) > -1 || user.email.indexOf(searchTerm) > -1) {
                            return user;
                        }
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.searchSempraUsersByTelephoneNumber = function (searchTerm) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/sempraUsers.json').success(function (data) {
                $timeout(function () {
                    var result = [];
                    if (searchTerm === '11111') {
                        result.push(data[0]);
                    } else if (searchTerm === '22222') {
                        result.push(data[1]);
                    } else if (searchTerm === '33333') {
                        result.push(data[2]);
                    }
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        // end sempra users

        //user groups CRUD

        this.getUserGroupById = function (groupId) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/groups.json').success(function (data) {
                $timeout(function () {
                    var result = data.find(function (group) {
                        return group.id.toString() === groupId.toString();
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getUserGroups = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/groups.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.createUserGroup = function (groupName) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({
                    id: 123
                });
            }, serverDelayMs);

            return deferred.promise;
        };

        this.updateUserGroup = function (groupId, groupName) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.deleteUserGroup = function (groupId) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        //end user groups CRUD

        // campaign templates

        var campaignTemplatesFetched = false,
            campaignTemplatesCache = [];

        this.getCampaignTemplateById = function (campaignTemplateId) {
            var deferred = $q.defer();

            if (campaignTemplatesFetched) {
                $timeout(function () {
                    var result = campaignTemplatesCache.find(function (campaignTemplate) {
                        return campaignTemplate.id.toString() === campaignTemplateId.toString();
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            } else {
                $http.get('../../../assets/mockData/campaignTemplates.json').success(function (data) {
                    $timeout(function () {
                        campaignTemplatesFetched = true;
                        campaignTemplatesCache = data;
                        var result = campaignTemplatesCache.find(function (campaignTemplate) {
                            return campaignTemplate.id.toString() === campaignTemplateId.toString();
                        });
                        deferred.resolve(result);
                    }, serverDelayMs);
                }).error(function (data, header, status) {
                    apiErrorHandlerService(data, header, status, deferred);
                });
            }

            return deferred.promise;
        };

        this.getCampaignTemplates = function () {
            var deferred = $q.defer();

            if (campaignTemplatesFetched) {
                $timeout(function () {
                    deferred.resolve(campaignTemplatesCache);
                }, serverDelayMs);
            } else {
                $http.get('../../../assets/mockData/campaignTemplates.json').success(function (data) {
                    $timeout(function () {
                        campaignTemplatesFetched = true;
                        campaignTemplatesCache = data;
                        deferred.resolve(campaignTemplatesCache);
                    }, serverDelayMs);
                }).error(function (data, header, status) {
                    apiErrorHandlerService(data, header, status, deferred);
                });
            }

            return deferred.promise;
        };

        this.createCampaignTemplate = function (newCampaignTemplate) {
            var deferred = $q.defer();

            $timeout(function () {
                newCampaignTemplate.id = campaignTemplatesCache.length + 1;
                campaignTemplatesCache.push(newCampaignTemplate);
                deferred.resolve(newCampaignTemplate);
            }, serverDelayMs);

            return deferred.promise;
        };

        this.updateCampaignTemplate = function (updatedCampaignTemplate) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignTemplatesCache.findIndex(function (campaignTemplate) {
                    return campaignTemplate.id.toString() === updatedCampaignTemplate.id.toString();
                });
                campaignTemplatesCache.splice(foundIndex, 1, updatedCampaignTemplate);
                deferred.resolve(updatedCampaignTemplate);
            }, serverDelayMs);


            return deferred.promise;
        };

        this.deleteCampaignTemplate = function (campaignTemplateId) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignTemplatesCache.findIndex(function (campaignTemplate) {
                    return campaignTemplate.id.toString() === campaignTemplateId.toString();
                });

                if (foundIndex > -1) {
                    campaignTemplatesCache.splice(foundIndex, 1);
                    deferred.resolve(campaignTemplateId);
                } else {
                    apiErrorHandlerService(campaignTemplateId);
                }
            }, serverDelayMs);

            return deferred.promise;
        };

        // end campaign templates

        // campaigns

        var campaignsFetched = false,
            campaignsCache = [];

        this.getCampaignById = function (campaignId) {
            var deferred = $q.defer();

            if (campaignsFetched) {
                $timeout(function () {
                    var result = campaignsCache.find(function (campaign) {
                        return campaign.id.toString() === campaignId.toString();
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            } else {
                $http.get('../../../assets/mockData/campaigns.json').success(function (data) {
                    $timeout(function () {
                        campaignsFetched = true;
                        campaignsCache = data;
                        var result = campaignsCache.find(function (campaign) {
                            return campaign.id.toString() === campaignId.toString();
                        });
                        deferred.resolve(result);
                    }, serverDelayMs);
                }).error(function (data, header, status) {
                    apiErrorHandlerService(data, header, status, deferred);
                });
            }

            return deferred.promise;
        };

        this.getCampaigns = function () {
            var deferred = $q.defer();

            if (campaignsFetched) {
                $timeout(function () {
                    deferred.resolve(campaignsCache);
                }, serverDelayMs);
            } else {
                $http.get('../../../assets/mockData/campaigns.json').success(function (data) {
                    $timeout(function () {
                        campaignsFetched = true;
                        campaignsCache = data;
                        deferred.resolve(campaignsCache);
                    }, serverDelayMs);
                }).error(function (data, header, status) {
                    apiErrorHandlerService(data, header, status, deferred);
                });
            }

            return deferred.promise;
        };

        this.createCampaign = function (newCampaign) {
            var deferred = $q.defer();

            $timeout(function () {
                newCampaign.id = campaignsCache.length + 1;
                campaignsCache.push(newCampaign);
                deferred.resolve(newCampaign);
            }, serverDelayMs);

            return deferred.promise;
        };

        this.updateCampaign = function (updatedCampaign) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignsCache.findIndex(function (campaign) {
                    return campaign.id.toString() === updatedCampaign.id.toString();
                });
                campaignsCache.splice(foundIndex, 1, updatedCampaign);
                deferred.resolve(updatedCampaign);
            }, serverDelayMs);


            return deferred.promise;
        };

        this.activateCampaign = function (campaignId) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignsCache.findIndex(function (campaign) {
                    return campaign.id.toString() === campaignId.toString();
                });
                campaignsCache[foundIndex].isActive = true;
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.deleteCampaign = function (campaignId) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignsCache.findIndex(function (campaign) {
                    return campaign.id.toString() === campaignId.toString();
                });

                if (foundIndex > -1) {
                    campaignsCache.splice(foundIndex, 1);
                    deferred.resolve(campaignId);
                } else {
                    apiErrorHandlerService(campaignId);
                }
            }, serverDelayMs);

            return deferred.promise;
        };


        // end campaigns

        this.getUsersForUserGroup = function (groupId, page, pageSize, orderBy, order) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/groupUsers.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.addUserToUserGroup = function (groupId, userId) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        };

        this.removeUserFromUserGroup = function (membershipId) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        };

        // INVOICES
        // get all invoices by selected date interval

        this.getPeriodicSummary = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/periodicSummary.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getInvoices = function (fromTimestamp, toTimestamp, page, pageSize, orderBy, order) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/invoices.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        // update new invoice
        this.updateInvoice = function (invoiceId, status) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        };

        this.createLocalTokens = function () {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        };

        this.getLocalTokensHistory = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/vouchers.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        }

        this.createVouchers = function () {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        }
        /* eslint-enable */
    }
})();
